import React, { useCallback, useContext, useMemo } from 'react';
import { DateTime, Info } from 'luxon';
import Square from '../Square';
import CalendarContext from '../CalendarContext';
import { Grid } from './styled';
function MonthView() {
    const { date, max, min, setDate, setView, value, locale } = useContext(CalendarContext);
    const handleChange = useCallback((month) => {
        setDate(date.set({ month }));
        setView('day');
    }, [date, setDate, setView]);
    const months = useMemo(() => Info.months('short', { locale }).map((month, index) => {
        const disabled = date.set({ month: index + 1 }).startOf('month') >
            DateTime.fromJSDate(max) ||
            date.set({ month: index + 1 }).endOf('month') <
                DateTime.fromJSDate(min);
        const valueDateTime = DateTime.fromJSDate(value);
        const selected = valueDateTime.year === date.year && valueDateTime.month === index + 1;
        return (React.createElement(Square, { key: month, disabled: disabled, "$altDisabled": disabled, selected: selected, onClick: () => handleChange(index + 1) }, month));
    }), [handleChange, date, max, min, value, locale]);
    return React.createElement(Grid, { view: "month" }, months);
}
export default MonthView;
